/* Sell page: read a set list out of a spreadsheet in the browser.
 *
 * Peter, 24 Sep 2026: "you need a place to put in a CSV document as well, which is very
 * important", then "can we put in the CSV spreadsheet?" The drop zone looked right and did
 * nothing, which is worse than not having it.
 *
 * This lives in its own file because it is full of regexes: when it was a template literal
 * inside render.mjs the backslashes were eaten and the page threw
 * "SyntaxError: Invalid regular expression".
 *
 * It does what the live page does (research/sell-funnel.md: #s1file accepts
 * .csv,.txt,.tsv,.xlsx,.xls and is parsed client side), plus real drag and drop.
 *
 * 28 Sep 2026, QUANTITIES WERE BEING LOST (Peter: "fix fix fix fix fix it"). Stephen Pickerill sent
 * 187 lines with quantities and every one arrived as one of each ("import has missed off
 * quantities"). The old reader only took a quantity sitting to the RIGHT of the set number, dropped
 * a set's second row instead of adding it, never read the header row (so a price or piece count
 * could become the quantity and a year could become a set number), and glued Excel rows together
 * with commas before splitting them again, so a set name with a comma in it shifted every column.
 * Now: the header row decides which column is the set and which is the quantity; price, year,
 * piece and date columns are never read as either; quantity is found on either side of the set;
 * a set on several rows is added up; Excel rows stay as real columns; the message says how many
 * boxes were read, so the seller can see the quantities came through.
 */
(function () {
  var zone = document.querySelector('.dropzone');
  var input = document.getElementById('listfile');
  var box = document.getElementById('list');
  if (!zone || !input || !box) return;
  var main = zone.querySelector('.dropzone__main');
  var LIMIT = 30000;          // the live page's cap on the textarea
  var idle = main.textContent;

  var SET_CELL = /^#?\s*(\d{4,7})(?:-\d{1,2})?$/;            // 75192, #75192, 75192-1
  var YEAR = /^(19[5-9]\d|20[0-4]\d)$/;
  var HEAD_QTY = /\b(qty|qnty|quantity|quantities|count|units?|how\s*many|no\.?\s*of|number\s*of|copies|stock|amount\s*of)\b/i;
  var HEAD_SET = /\b(set|item|product|lego|model|catalogue|catalog|stock)\s*(no\.?|num\.?|number|code|id|ref|#)|^\s*(set|sets|number|no\.?|code|ref|set\s*#|item|product)\s*$/i;
  var HEAD_HOWMANY = /\b(no\.?\s*of|number\s*of|how\s*many)\b/i;
  var HEAD_SKIP = /price|rrp|cost|value|paid|worth|sold|pieces|pcs|piece|year|date|age|retire|release|launch|weight/i;

  // One line of a text file into cells. Delimiter chosen once per file; quoted cells may hold it.
  function splitLine(line, d) {
    var out = [], cur = '', q = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line.charAt(i);
      if (ch === '"') { if (q && line.charAt(i + 1) === '"') { cur += '"'; i++; } else q = !q; }
      else if (ch === d && !q) { out.push(cur); cur = ''; }
      else cur += ch;
    }
    out.push(cur);
    return out;
  }
  function textToRows(text) {
    var lines = text.split(/\r\n|\r|\n/).filter(function (l) { return l.trim(); });
    var sample = lines.slice(0, 20).join('\n');
    var count = function (re) { var m = sample.match(re); return m ? m.length : 0; };
    var d = count(/\t/g) ? '\t' : (count(/;/g) > count(/,/g) ? ';' : (count(/,/g) ? ',' : (count(/\|/g) ? '|' : null)));
    return lines.map(function (l) { return d ? splitLine(l, d) : [l]; });
  }

  function cellStr(c) { return String(c == null ? '' : c).replace(/^"|"$/g, '').trim(); }
  function setOf(c) { var m = cellStr(c).match(SET_CELL); return m ? m[1] : null; }
  function qtyOf(c, max) {
    var s = cellStr(c);
    if (!s) return null;
    var m = s.match(/^(?:x\s*)?(\d{1,4})(?:\s*(?:x|pcs?|boxes|sets?|units?))?$/i);
    if (!m) return null;
    var n = Number(m[1]);
    return n >= 0 && n <= max ? n : null;
  }

  // Find a header row in the first few rows: no set-number cell in it, and a set or qty column named.
  function findHeader(rows) {
    for (var i = 0; i < Math.min(rows.length, 6); i++) {
      var r = rows[i], setCol = -1, weakSet = -1, qtyCol = -1, skip = {}, named = false;
      if (r.some(function (c) { return setOf(c); })) continue;
      for (var j = 0; j < r.length; j++) {
        var h = cellStr(r[j]);
        if (!h) continue;
        // "Set Number" beats a bare "Set", which is often the name column (nitro_howard's sheet: Set | Set Number).
        if (HEAD_SET.test(h) && !HEAD_HOWMANY.test(h)) {
          if (/\b(no\.?|num\.?|number|code|id|ref|#)/i.test(h)) { if (setCol < 0) setCol = j; } else if (weakSet < 0) weakSet = j;
          named = true; continue;
        }
        if (HEAD_QTY.test(h) && !/price|cost|value/i.test(h)) { if (qtyCol < 0) qtyCol = j; named = true; continue; }
        if (HEAD_SKIP.test(h)) { skip[j] = 1; named = true; }
      }
      if (named) return { row: i, setCol: setCol >= 0 ? setCol : weakSet, qtyCol: qtyCol, skip: skip };
    }
    return null;
  }

  function parseRows(rows) {
    rows = rows.map(function (r) { return (Array.isArray(r) ? r : [r]).map(cellStr); }).filter(function (r) { return r.some(function (c) { return c; }); });
    var head = findHeader(rows);
    var totals = {}, order = [];
    function add(set, n) {
      if (!set || !(n > 0)) return;
      if (!(set in totals)) { totals[set] = 0; order.push(set); }
      totals[set] += n;
    }
    for (var i = head ? head.row + 1 : 0; i < rows.length; i++) {
      var r = rows[i], set = null, setAt = -1, qty = null, j;
      if (head && head.setCol >= 0) {
        set = setOf(r[head.setCol]);
        if (!set) { var inl = String(r[head.setCol] || '').match(/\b(\d{4,7})\b/); if (inl && !YEAR.test(inl[1])) set = inl[1]; }
        setAt = head.setCol;
      }
      if (!set) {
        // No set column named: the first set-shaped cell that is not a year and not in a skipped column wins.
        var years = [];
        for (j = 0; j < r.length; j++) {
          if (head && (head.skip[j] || j === head.qtyCol)) continue;
          var s = setOf(r[j]);
          if (!s) continue;
          if (YEAR.test(s)) { years.push(j); continue; }
          set = s; setAt = j; break;
        }
        if (!set && years.length === 1 && r.filter(function (c) { return /\d/.test(c); }).length === 1) { set = setOf(r[years[0]]); setAt = years[0]; }
      }
      if (!set) {
        // Free text: "75192 x2", "2 x 75192", "LEGO 75192 Millennium Falcon".
        var line = r.join(' ');
        var a = line.match(/\b(\d{1,3})\s*x\s*#?(\d{4,7})\b/i);
        var b = line.match(/\b(\d{4,7})\b(?:\s*(?:-\d{1,2})?\s*x\s*(\d{1,3})\b)?/i);
        if (a && !YEAR.test(a[2])) { set = a[2]; qty = Number(a[1]); }
        else if (b && !YEAR.test(b[1])) {
          set = b[1];
          if (b[2]) qty = Number(b[2]);
          else { var tail = line.replace(b[0], ' ').match(/\bx\s*(\d{1,3})\b|\b(\d{1,3})\s*x\b/i); if (tail) qty = Number(tail[1] || tail[2]); }
        }
      }
      if (!set) continue;
      if (qty === null && head && head.qtyCol >= 0) {
        qty = qtyOf(r[head.qtyCol], 9999);
        if (qty === 0) continue;                      // a zero in the quantity column means none held
      }
      if (qty === null && !(head && head.qtyCol >= 0)) {
        // No quantity column named: a small whole number either side of the set, never from a skipped column.
        for (j = 0; j < r.length; j++) {
          if (j === setAt || (head && head.skip[j])) continue;
          var n = qtyOf(r[j], 199);
          if (n !== null && n > 0) { qty = n; break; }
        }
      }
      add(set, qty === null ? 1 : qty);
    }
    var units = 0;
    var lines = order.map(function (s) { units += totals[s]; return totals[s] > 1 ? s + ' x' + totals[s] : s; });
    return { lines: lines, units: units };
  }
  function parse(text) { return parseRows(textToRows(text)); }

  function say(msg) { main.textContent = msg; }
  function put(found, name) {
    if (!found.lines.length) { say('No set numbers found in ' + name + '. Paste the list in instead, or email it over.'); return; }
    var add = found.lines.join('\n');
    box.value = box.value.trim() ? box.value.trim() + '\n' + add : add;
    if (box.value.length > LIMIT) box.value = box.value.slice(0, LIMIT);
    var n = found.lines.length;
    say(n + ' set' + (n === 1 ? '' : 's') + ' (' + found.units + ' box' + (found.units === 1 ? '' : 'es') + ') read from ' + name + '. Each line is the set number and how many you have. Check the box above and change anything that is wrong.');
    box.focus();
  }

  // Excel is read by SheetJS fetched on demand, exactly as the live sell page does, so the
  // page stays light for everyone who never picks an .xlsx. The file never leaves the browser.
  function readExcel(file) {
    var go = function () {
      var fr = new FileReader();
      fr.onload = function () {
        try {
          var wb = XLSX.read(new Uint8Array(fr.result), { type: 'array' });
          var found = { lines: [], units: 0 };
          // First sheet that has sets in it (a cover or notes sheet in front is common).
          for (var k = 0; k < wb.SheetNames.length && !found.lines.length; k++) {
            var rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[k]], { header: 1, blankrows: false, raw: false });
            found = parseRows(rows);
          }
          put(found, file.name);
        } catch (e) { say('Could not read ' + file.name + '. Save it as CSV and try again, or email it to sell@buymybricks.com.'); }
      };
      fr.readAsArrayBuffer(file);
    };
    if (window.XLSX) return go();
    say('Reading ' + file.name + '...');
    var sc = document.createElement('script');
    sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
    sc.onload = go;
    sc.onerror = function () { say('Could not load the Excel reader. Save the file as CSV and try again.'); };
    document.head.appendChild(sc);
  }

  function load(file) {
    if (!file) return;
    if (/\.xlsx?$/i.test(file.name)) { readExcel(file); return; }
    if (file.size > 5 * 1024 * 1024) {
      say('That file is over 5MB. Email it to sell@buymybricks.com and we will read it this end.');
      return;
    }
    var reader = new FileReader();
    reader.onload = function () { put(parse(String(reader.result)), file.name); };
    reader.onerror = function () {
      say('Could not read ' + file.name + '. Email it to sell@buymybricks.com and we will sort it.');
    };
    reader.readAsText(file);
  }

  if (window.BMB_SELL_CSV_TEST) { window.BMB_SELL_CSV_TEST.parse = parse; window.BMB_SELL_CSV_TEST.parseRows = parseRows; }

  input.addEventListener('change', function () { load(input.files && input.files[0]); });

  ['dragenter', 'dragover'].forEach(function (name) {
    zone.addEventListener(name, function (ev) { ev.preventDefault(); zone.classList.add('is-over'); say('Drop it'); });
  });
  ['dragleave', 'dragend'].forEach(function (name) {
    zone.addEventListener(name, function (ev) { ev.preventDefault(); zone.classList.remove('is-over'); say(idle); });
  });
  zone.addEventListener('drop', function (ev) {
    ev.preventDefault();
    zone.classList.remove('is-over');
    load(ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0]);
  });
}());
